import { render, staticRenderFns } from "./SurfaceHeaderMobile.vue?vue&type=template&id=09ba1900&scoped=true&"
import script from "./SurfaceHeaderMobile.vue?vue&type=script&lang=ts&"
export * from "./SurfaceHeaderMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SurfaceHeaderMobile.vue?vue&type=style&index=0&id=09ba1900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba1900",
  null
  
)

export default component.exports